<template>
  <v-toolbar flat class="mb-4">
    <v-toolbar-title>
      {{ title }}
      <span></span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div>
      <v-tooltip bottom v-if="permitted('SignalTest.View')">
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            small
            text
            outlined
            color="accent"
            router
            to="/signaltest"
            v-on="on"
          >
            <v-icon dark>mdi-access-point</v-icon> {{ $t("routes.signalTest") }}
          </v-btn>
        </template>
        <span>{{ $t("routes.signalTest") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            fab
            small
            color="accent"
            router
            to="/gateways"
            v-on="on"
          >
            <v-icon dark>mdi-access-point</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("gateway.toolbar") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            fab
            small
            color="primary"
            router
            to="/gateways/create"
            v-on="on"
            v-if="permitted('Gateways.Create')"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("common.create") }}</span>
      </v-tooltip>
    </div>
  </v-toolbar>
</template>

<script>
import { Roles } from "@/_helpers/Role";
export default {
  name: "GatewayToolbar",
  props: ["title"],
  computed: {
    Roles() {
      return Roles;
    },
  },
};
</script>
